export default __webpack_public_path__ + "static/media/404_2.a0396b78.png";